import { RootState } from '../../../store';

export const getExchangeRates = (state: RootState) => state.exchangeRates.exchangeRates;
